import React from 'react';

import PropTypes from 'prop-types';

import DrawerContent from './DrawerContent';
import { getDrawerSizeInPX } from './helpers';
import StyledDrawer from './StyledComponents/StyledDrawer';

const SideBar = ({
    drawerSize,
    handleDrawerToggle,
    match,
    mobileOpen,
    profileValues,
    redirect,
    selectedTheme,
    setMobileOpen,
    setSidebarOpen,
    setTheme,
    sidebarOpen,
    toggleDrawerSize,
}) => {
    const container =
        window !== undefined ? () => window.document.body : undefined;

    const onMouseEnter = () => {
        if (drawerSize === 'small') {
            setSidebarOpen(true);
            return;
        }
        setSidebarOpen(false);
    };

    const onMouseLeave = () => {
        if (drawerSize === 'small') {
            setSidebarOpen(false);
        }
    };

    const sx = {
        display: { md: 'block', xs: 'none' },
        '& .MuiDrawer-paper': {
            width: sidebarOpen
                ? getDrawerSizeInPX('normal')
                : getDrawerSizeInPX(drawerSize),
            overflowX: 'hidden',
        },
    };

    const sxTemporaryDrawer = {
        display: { md: 'none', xs: 'block' },
        '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
        },
    };

    const drawerContent = (
        <DrawerContent
            {...{
                container,
                drawerSize: sidebarOpen ? 'normal' : drawerSize,
                handleDrawerToggle,
                match,
                mobileOpen,
                profileValues,
                redirect,
                selectedTheme,
                setMobileOpen,
                setSidebarOpen,
                setTheme,
                sidebarOpen,
                toggleDrawerSize,
            }}
        />
    );
    return (
        <>
            <StyledDrawer
                drawersize={drawerSize}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                sx={sx}
                variant="permanent"
            >
                {drawerContent}
            </StyledDrawer>

            <StyledDrawer
                container={container}
                drawersize={drawerSize}
                ModalProps={{ keepMounted: true }}
                open={mobileOpen}
                onClose={handleDrawerToggle}
                sx={sxTemporaryDrawer}
                variant="temporary"
            >
                {drawerContent}
            </StyledDrawer>
        </>
    );
};

SideBar.propTypes = {
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    match: PropTypes.object,
    mobileOpen: PropTypes.bool,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setMobileOpen: PropTypes.func,
    setSidebarOpen: PropTypes.func,
    setTheme: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    toggleDrawerSize: PropTypes.func,
};

export default SideBar;
